export class MatchDefinition {
    constructor(data) {
        
        this.MatchPlayFormat = data.MatchPlayFormat;
        this.MatchPlayers1 = data && data.MatchPlayers1 ? data.MatchPlayers1 : [];
        this.MatchPlayers2 = data && data.MatchPlayers2 ? data.MatchPlayers2 : [];
        this.MatchNumberOfSets = data.MatchNumberOfSets;
    }
}